{
  "actions.logout": "Logout",
  "actions.language": "Lingua",
  "actions.support_request": "Richiesta di supporto",
  "actions.download": "Scaricare",
  "actions.print": "Stampa",
  "documents.preview.cant_be_previewed": "Il file non può essere visualizzato in anteprima.",
  "documents.preview.node_actions.pages": "{currentPage} di {totalPages} pagine",
  "errors.error_occurred": "Si è verificato un errore",
  "actions.cancel": "Annullare",
  "actions.confirm": "Confermare",
  "actions.delete": "Eliminare",
  "actions.save": "Salva",
  "article.new": "Nuovo articolo della Knowledge Base",
  "article.create": "Crea articolo",
  "article.edit": "Modifica articolo",
  "article.remove": "Elimina articolo",
  "article.state.draft": "Bozza",
  "article.state.migrated": "Migrato",
  "article.state.published": "Pubblicato",
  "article.state.delete-requested": "Richiesta di eliminazione",
  "article.state.deleted": "Eliminato",
  "article.visibility.internal": "Interno",
  "article.visibility.public": "Pubblico",
  "folder.create": "Crea cartella",
  "folder.delete": "Elimina cartella",
  "folder.delete-confirmation": "Sei sicuro di voler eliminare questa cartella?",
  "chat.title": "Chat",
  "chat.all": "Chat su tutto",
  "chat.kb": "Chat KB",
  "chat.kb_attachment": "Allegato KB",
  "chat.ticket": "Ticket",
  "chat.jira": "Chat Jira",
  "title": "Titolo",
  "problem": "Problema",
  "solution": "Soluzione",
  "application": "Applicazione",
  "affected-versions": "Versioni interessate",
  "from": "Da",
  "to": "A",
  "affected-servicepack": "Pacchetto di servizi",
  "environment-system": "Ambiente / Sistema",
  "parent-element": "Elemento principale",
  "visibility": "Visibilità",
  "created-by": "Creato da",
  "on": "il",
  "recently-edited-by": "Modificato da",
  "edit": "Modifica",
  "review-migrations": "Revisione delle migrazioni",
  "review": "Revisione",
  "confirm-delete": "Conferma eliminazione",
  "save-for-review": "Salva per revisione",
  "publish": "Pubblica",
  "release": "Rilascia",
  "description-problem": "Descrizione / Problema",
  "attachments": "Allegati",
  "compare": "Confronta {left} - {right}",
  "all": "Tutti",
  "unassigned": "Non assegnato",
  "id": "ID",
  "status": "Stato",
  "last-editor": "Ultimo editore",
  "edited-at": "Modificato il",
  "current": "Attuale",
  "previous": "Precedente",
  "editor": "Editore",
  "version": "Versione",
  "compare-with": "Confronta con",
  "main": "Generale",
  "versions": "Versioni",
  "request-removal": "Richiedi rimozione",
  "yes-remove": "Sì, elimina",
  "remove": "Elimina",
  "retract": "Ritirare",
  "search": "Cerca ...",
  "please-specify-new-folder-name": "Specifica il nome della nuova cartella",
  "name": "Nome",
  "unable-to-create-new-folder-error": "Impossibile creare una nuova cartella: {0}",
  "knowledge-base": "Knowledge Base",
  "access-denied": "Accesso negato",
  "article.article-needs-verification": "L'articolo verrà verificato da un'altra persona dopo il salvataggio. Selezionare l'utente desiderato.",
  "article.article-not-found": "L'articolo non è stato trovato.",
  "article.do-not-remove-article": "Non rimuovere l'articolo",
  "article.do-you-want-to-remove-this-article": "Vuoi davvero eliminare questo articolo? Questa azione non può essere annullata.",
  "article.download-pdf": "Scarica come PDF",
  "article.removal-requires-approval": "La rimozione dell'articolo deve essere confermata da un revisore. Seleziona l'utente desiderato.",
  "article.watch-article": "Segui l'articolo",
  "article.watched": "Articoli seguiti",
  "article.watched-article": "Articolo seguito",
  "tickets.ticket-not-found": "Il ticket non è stato trovato",
  "tickets.state.draft": "Bozza",
  "tickets.state.published": "Pubblicato",
  "errors.check_your_inputs": "Controlla i tuoi inserimenti",
  "assigned": "Assegnato",
  "last-reviewer": "Ultimo revisore",
  "page-guard.changes-not-saved": "Vuoi davvero uscire dal modulo? Le modifiche apportate non saranno salvate.",
  "page-guard.changes-not-saved-title": "Modifiche non salvate",
  "continue": "Continuare",
  "chat.delete_all": "Elimina tutte le chat",
  "chat.no_chats_saved": "Nessuna chat salvata",
  "chat.documents": "Documenti",
  "chat.course_material": "Materiale didattico",
  "chat.release_courses": "Corsi sulle novità",
  "chat.misc_docs": "Altri documenti",
  "chat.news": "News per i partner",
  "chat.release_info": "Informazioni di release",
  "chat.f1_hilfe": "Guida F1",
  "chat.new_chat": "Nuova chat",
  "article.needs_transations": "L'articolo necessita di traduzioni",
  "languages.de": "Tedesco",
  "languages.en": "Inglese",
  "languages.fr": "Francese",
  "languages.it": "Italiano",
  "language-not-supported": "Lingua non supportata",
  "edit-translation": "Modifica traduzione",
  "save-translation": "Salva la traduzione",
  "error": "Errore",
  "article.versions.to": "Fino a",
  "article.versions.from": "A partire da",
  "servicepack": "Pacchetto di servizi",
  "max-count": "max {0}",
  "article.versions.from_to_entry": "Inserimento Da / A",
  "select-applications": "Seleziona le applicazioni",
  "load-applications": "Carica le applicazioni",
  "select-servicepack": "Seleziona il pacchetto di servizi",
  "load-servicepacks": "Caricamento dei pacchetti di servizio",
  "select-version": "Scegli la versione",
  "load-versions": "Caricamento versioni",
  "chat.reply_stopped": "Questa risposta è stata interrotta",
  "report": "Segnalare",
  "open-source": "Apri fonte",
  "sources": "Fonti",
  "matches": "Risultati",
  "chat.sources_empty_text": "Non appena farai una domanda, le fonti appariranno qui.",
  "chat.empty_text": "Come posso aiutarti oggi?",
  "hello": "Ciao",
  "chat.filter.collection.all": "Tutto",
  "chat.prompt_placeholder": "Fai la tua domanda",
  "send": "Inviare",
  "chat.report_answer": "Riporta la risposta",
  "chat.your_message": "Il tuo messaggio",
  "chat.diagram_loading": "Creazione del diagramma…",
  "chat.diagram_open": "Apri diagramma",
  "chat.diagram_filename": "diagramma.png",
  "cancel": "Cancellare",
  "refresh": "Aggiorna",
  "to-migrate": "Da migrare",
  "not-assigned": "Non assegnati",
  "to-do": "Da fare",
  "article.dashboard.external_user.welcome_text": "Per trovare l'articolo della Knowledge Base desiderato, utilizzare il campo di ricerca o selezionare una categoria.",
  "last-updated": "Ultimi aggiornamenti",
  "old": "Vecchio",
  "new": "Nuovo",
  "summary": "Riepilogo",
  "tickets.support_request": "Richiesta di supporto",
  "clarifications": "Chiarimenti",
  "to-review": "Da revisionare",
  "tickets.ticket_no": "Ticket n.",
  "date": "Data",
  "tickets.needs_transations": "Il ticket necessita di traduzioni",
  "users.group_search_or_select": "Cerca o seleziona un gruppo",
  "users.favorites": "Preferiti",
  "users.all_users": "Tutti gli utenti",
  "users.favorite_add": "Aggiungi ai preferiti",
  "users.favorite_remove": "Rimuovi dai preferiti",
  "users.user_search_or_select": "Cerca o seleziona utente",
  "admin.title": "Amministrazione",
  "admin.chat.reports": "Segnalazioni della chat",
  "article.errors.save_conflict": "L’articolo è stato modificato da qualcun altro nel frattempo. Ti preghiamo di ricaricare la pagina e riprovare.",
  "tickets.errors.save_conflict": "Il ticket è stato modificato da qualcun altro nel frattempo. Ti preghiamo di ricaricare la pagina e riprovare.",
  "project": "Progetto",
  "article.language.alert.translation_text": "Traduzione {lang} di questo articolo",
  "article.language.alert.english": "inglese",
  "article.language.alert.french": "francese",
  "article.language.alert.italian": "italiana",
  "article.language.alert.only_relevant_fields": "Vengono visualizzati solo i campi rilevanti per la traduzione.",
  "article.language.show_original": "Mostra originale (DE)",
  "article.language.original_article": "Articolo originale (DE)",
  "admin.chat.table_headers.report": "Segnalazione",
  "admin.chat.table_headers.chat_filter": "Filtro della chat",
  "admin.chat.table_headers.reported_by": "Segnalato da",
  "admin.chat.table_headers.reported_on": "Segnalato il",
  "admin.chat.detail_title": "Dettagli segnalazione",
  "tickets.back_to_list": "Torna alla lista",
  "tickets.show_old": "Mostra VECCHIO",
  "filter": "Filtro",
  "my-employee-group": "Mio gruppo dipendenti",
  "preview": "Anteprima",
  "preview.previous_attachment": "Allegato precedente",
  "preview.next_attachment": "Allegato successivo",
  "article.restore_this_revision": "Ripristina questa versione",
  "page-guard.back-to-form": "Torna al modulo",
  "page-guard.discard-changes": "Scarta le modifiche",
  "time.just_now": "appena adesso",
  "time.yesterday_at": "ieri alle",
  "is-saving": "Salvataggio",
  "last-saved": "Ultimo salvataggio",
  "article.discard_my_changes": "Annulla le mie modifiche",
  "article.no_changes_yet": "nessuna modifica ancora",
  "actions.close": "Chiudere",
  "article.autosave.hint_not_up_to_date": "Questo articolo è stato modificato da qualcun altro, quindi le tue modifiche potrebbero essere obsolete. Puoi annullare le tue modifiche per poi modificare la versione più recente.",
  "article.autosave.hint_saved_changes": "Hai delle modifiche salvate per questo articolo.",
  "outdated": "Superato",
  "article.autosave.version_status": "Stato",
  "article.autosave.pending_changes": "Le mie modifiche aperte",
  "article.autosave.load_error": "Impossibile caricare i progressi salvati. Vuoi ancora aprire l'articolo? Il tuo progresso salvato potrebbe essere sovrascritto.",
  "open-anyway": "Aprire lo stesso",
  "article.autosave.show_my_changes": "Visualizza le mie modifiche",
  "article.migrated_alert": "Questo articolo non è stato rivisto dopo la migrazione dalla vecchia Knowledge Base.",
  "development": "Sviluppo",
  "select-reviewer": "Seleziona revisore",
  "users.select_group_text": "Seleziona il gruppo desiderato.",
  "tickets.state.not_relevant": "Non rilevante",
  "tickets.state.migrated": "Migrato",
  "tickets.state.not_relevant_requested": "Non rilevante richiesto",
  "tickets.unused_requires_approval": "Questa azione deve essere confermata da un revisore. Selezionare l'utente desiderato.",
  "tickets.change_to_relevant": "Cambia in pertinente",
  "tickets.confirm_not_relevant": "Conferma non rilevante",
  "tickets.ticket_not_relevant": "Il ticket non è rilevante",
  "count-selected": "{0} selezionati",
  "assign": "Assegnare",
  "assign-group": "Assegna gruppo",
  "group": "Gruppo",
  "users.select_user_text": "Selezionare l'utente desiderato.",
  "tickets.assign_ticket_count": "Assegna {0} ticket",
  "tickets.assign_group_count": "Assegna {0} ticket a un gruppo",
  "chat.delete_all_msg": "Sei sicuro di voler eliminare tutte le chat?",
  "chat.deleta_all_confirm": "Sì, elimina",
  "reject": "Rifiutare",
  "folder.rename": "Rinomina cartella",
  "unable-to-rename-folder-error": "Impossibile rinominare la cartella: {0}",
  "move": "Spostare",
  "yes-move": "Sì, spostare",
  "tree.really_move": "Sei sicuro di voler spostare <b>{0}</b> in <b>{1}</b>?",
  "tree.folder_to_kb_warning": "Non è possibile spostare una directory in un KB.",
  "tree.really_move_to_root": "Sei sicuro di voler spostare <b>{0}</b> al <b>livello principale</b>?",
  "tree.hint_search_result": "{0} di {1} risultati",
  "nothing-found": "Nessun risultato trovato",
  "tickets.keep_original": "Accetta il ticket originale",
  "article.visibility.c3_internal_it": "C3 IT interna",
  "article.visibility.c3_deepcloud": "C3 DeepCloud",
  "description": "Descrizione",
  "jira.jira_not_found": "Il ticket Jira non è stato trovato oppure non hai accesso.",
  "jira.labels.components": "Componente(i)",
  "jira.labels.solution_versions": "Versione/i della soluzione",
  "created": "Creato il",
  "author": "Autore",
  "priority": "Priorità",
  "jira.labels.external_contacts": "Contatti esterni",
  "jira.labels.affected_versions": "Versione/i interessata/e",
  "last-modified": "Ultima modifica",
  "details": "Dettagli",
  "type": "Tipo",
  "modified": "Modificato",
  "kb.edit.insert-attachment-link": "Allegato",
  "comments": "Commenti",
  "jira.comments.edited": "modificato",
  "jira.comments.no_comments": "Nessun commento",
  "jira.comments.sort_newest_first": "Recenti prima",
  "jira.comments.sort_oldest_first": "Vecchi prima",
  "save": "Salva",
  "change-status": "Cambia stato",
  "admin.chat.status.new": "Nuovo",
  "admin.chat.status.read": "Letto",
  "admin.chat.status.in_progress": "In corso",
  "admin.chat.status.fixed": "Fisso",
  "admin.chat.status.wont_fix": "Non verrà risolto",
  "admin.chat.set_status_dialog.note": "Nota (facoltativa)",
  "admin.chat.admin_note": "Nota admin",
  "admin.chat.handled_by": "Gestito da {name} il {date}",
  "watchers": "Osservatori",
  "jira.errors.watchers_refresh": "Non è stato possibile aggiornare l'elenco degli osservatori",
  "jira.no_watchers_yet": "Nessun osservatore",
  "jira.watched": "Osservato",
  "jira.watch": "Osservare",
  "jira.filter.only_watched": "Solo osservati",
  "jira.no_attachments": "Nessun allegato",
  "jira.links.title": "Collegamenti",
  "jira.links.remote_group": "è collegato a",
  "jira.links.no_links": "Nessun collegamento",
  "notifications.settings.title": "Notifiche e-mail",
  "notifications.settings.description": "Scegli per quali eventi desideri essere avvisato via e-mail.",
  "notifications.settings.saved": "Impostazioni aggiornate",
  "notifications.settings.event_type.kb_followed_article_changed": "Modifiche agli articoli KB seguiti",
  "notifications.settings.event_type.kb_review_approved": "Approvazione di un articolo KB modificato",
  "notifications.settings.event_type.kb_review_rejected": "Rifiuto di un articolo KB modificato",
  "notifications.settings.event_type.kb_assigned": "Assegnazione di un articolo KB",
  "notifications.settings.event_type.ticket_review_approved": "Approvazione di un ticket modificato",
  "notifications.settings.event_type.ticket_review_rejected": "Un ticket modificato valutato come non utilizzabile",
  "notifications.settings.event_type.ticket_assigned": "Assegnazione di un ticket",
  "notifications.settings.event_type.jira_followed_issue_updated": "Modifiche ai ticket Jira seguiti",
  "tickets.state.not_relevant_ai": "Non rilevante (IA)",
  "wish_ticket.open": "Modulo dei desideri",
  "wish_ticket.title": "Desideri relativi all'applicazione",
  "wish_ticket.email": "E-mail",
  "wish_ticket.customer_name": "Nome del cliente",
  "wish_ticket.customer_license": "Licenza del cliente",
  "wish_ticket.section_description": "Descrizione del desiderio",
  "wish_ticket.description": "Descrizione precisa del requisito (situazione iniziale, comportamento attuale vs. comportamento atteso)",
  "wish_ticket.use_cases": "Quali casi d'uso (user story) devono essere coperti / supportati?",
  "wish_ticket.frequency.label": "Con quale frequenza si presenta questo caso d'uso? Con quale frequenza potrebbe essere utilizzata la nuova funzione?",
  "wish_ticket.frequency.multiple_per_day": "Frequentemente (più volte al giorno)",
  "wish_ticket.frequency.multiple_per_week": "Spesso (più volte alla settimana)",
  "wish_ticket.frequency.weekly_monthly": "Regolarmente (1x alla settimana/al mese)",
  "wish_ticket.frequency.rarely": "Raramente (1x all'anno, occasionalmente)",
  "wish_ticket.frequency.once": "Una tantum",
  "wish_ticket.target_audience": "A chi è destinata la nuova funzione? (ad es. contabili, collaboratori, partner commerciali, fiduciari, ecc.)",
  "wish_ticket.benefit": "Quale beneficio complessivo si può trarre da questa estensione? (ad es. semplificazione dei processi, aumento dell'efficienza, automazione, ecc.)",
  "wish_ticket.discussed_with_abacus": "Il desiderio è già stato discusso con qualcuno presso Abacus Research AG?",
  "wish_ticket.yes": "Sì",
  "wish_ticket.no": "No",
  "wish_ticket.additional_info": "Ulteriori informazioni (Con chi è stato discusso? Esiste già un Jira o una KB noti?)",
  "wish_ticket.privacy": "Protezione dei dati",
  "wish_ticket.privacy_text": "Ho preso atto della {link}.",
  "wish_ticket.privacy_link": "dichiarazione sulla protezione dei dati",
  "wish_ticket.submit": "Inviare il desiderio",
  "wish_ticket.sent": "Il suo desiderio è stato inviato",
  "wish_ticket.please_select": "– selezionare –",
  "live_status.button": "Stato",
  "live_status.title": "Stato dei servizi",
  "live_status.all_ok": "Tutti i sistemi sono operativi",
  "live_status.issue": "Alcuni servizi sono compromessi",
  "live_status.unreachable": "Impossibile recuperare lo stato dei servizi",
  "live_status.loading": "Caricamento dello stato dei servizi…",
  "ops.cases": "Casi",
  "ops.case.create": "Registra caso",
  "ops.case.delete": "Elimina caso",
  "ops.case.delete_confirmation": "Vuoi davvero eliminare questo caso? Scomparirà da tutti gli elenchi e dalla chat.",
  "ops.case.deleted": "Caso eliminato",
  "ops.case.saved": "Caso salvato",
  "ops.case.load_error": "Non è stato possibile caricare il caso.",
  "ops.case.required": "Campo obbligatorio",
  "ops.case.case_no": "Numero del caso",
  "ops.case.case_no_pending": "Assegnato al salvataggio",
  "ops.case.folder": "Cartella",
  "ops.case.reported_at": "Data della segnalazione",
  "ops.case.affected_users": "Utenti interessati",
  "ops.case.os": "OS",
  "ops.case.os_build": "Build del SO",
  "ops.case.version_patch": "Versione / patch Abacus",
  "ops.case.applications": "Applicazioni interessate",
  "ops.case.frequency": "Frequenza / regolarità",
  "ops.case.frequency_hint": "p. es. ogni giorno a mezzogiorno, sempre il 24",
  "ops.case.programs": "Programmi interessati",
  "ops.case.services": "Servizi interessati",
  "ops.case.required_data": "Dati necessari per l'analisi",
  "ops.case.required_data_hint": "p. es. heap dump e sysinfo",
  "ops.case.jira_keys": "Jira interessati",
  "ops.case.ticket_numbers": "Ticket interessati",
  "ops.case.workarounds": "Soluzioni alternative",
  "ops.case.solutions": "Soluzioni",
  "ops.analysis.title": "Analisi",
  "ops.analysis.add": "Aggiungi analisi",
  "ops.analysis.count": "Analisi",
  "ops.analysis.empty": "Nessuna analisi registrata.",
  "ops.analysis.entry_title": "Analisi {0}",
  "ops.analysis.saved": "Analisi salvata",
  "ops.analysis.delete": "Elimina analisi",
  "ops.analysis.delete_confirmation": "Vuoi davvero eliminare questa analisi, inclusi i suoi file?",
  "ops.analysis.cpu": "CPU",
  "ops.analysis.memory": "Memoria",
  "ops.analysis.diskspeed": "Velocità del disco",
  "ops.analysis.abacus_services": "Servizi Abacus",
  "ops.analysis.procedure": "Analisi / procedura",
  "ops.analysis.log_entries": "Voci di log",
  "ops.analysis.thread_stack": "Thread stack determinante",
  "ops.analysis.heapdump_ref": "Riferimento heap dump",
  "ops.analysis.heapdump_ref_hint": "Percorso o link all'heap dump (nessun caricamento)",
  "ops.files.title": "File (thread dump, dump Prometheus, …)",
  "ops.files.hint": "Max. {0} per file",
  "ops.files.too_large": "«{0}» supera {1} e non può essere caricato. Riduci o dividi il file.",
  "servicepack_none": "Nessun pacchetto di servizi",
  "ops.case.folder_root": "Livello superiore (nessuna cartella)",
  "ops.analysis.edit": "Modifica analisi",
  "ops.analysis.files_after_save": "Salva prima l'analisi per allegare file.",
  "ops.analysis.no_details": "Nessun dettaglio registrato.",
  "ops.analysis.file_count": "{0} file",
  "ops.case.edit": "Modifica caso",
  "ops.case.affected_users_hint": "Numero"
}
